<template>
  <div class="empty-state">
    <div class="empty-state--icon-wrapper">
      <v-icon class="mr-2 empty-state--icon">
        {{ icon }}
      </v-icon>
    </div>
    <h3 class="empty-state--text">
      {{ text }}
    </h3>
  </div>
</template>
<script>
  export default {
    name: 'EmptyState',
    props: {
      icon: {
        type: String,
        default: '$faHome',
      },
      text: {
        type: String,
        default: 'No results found',
      },
    },
  }
</script>
<style lang="scss">
.empty-state {
  min-height: 400px;
  padding: 100px 20px;
  .empty-state--icon-wrapper {
    border-radius: 50px;
    width: 83px;
    height: 83px;
    background: $na-dark-cream;
    padding: 21.75px 23px;
    margin: 0 auto 30px;
    .empty-state--icon > * {
     // Fixes icons for mozilla
      width: 38px !important;
      height: 35px !important;
      color: $muted;
    }
  }
  .empty-state--text {
    color: #535353;
    font-family: "Degular", sans-serif;
    font-size: 25px;
    letter-spacing: 0.3px;
    line-height: 32px;
    text-align: center;
  }
}
.v-skeleton-loader__image {
  min-height:100%;
}
</style>
